import AppForm from '../app-components/Form/AppForm';

Vue.component('restaurant-form', {
    mixins: [AppForm],
    props: {
        'defaultCountry': {
            type: String,
            required: false,
            default: ''
        },
        'dynamicFields': {
            type: Array,
            required: false,
            default: () => []

        }
    },

    data: function() {
        return {
            form: {
                custom_id: '',
                restaurant_code:  '',
                title:  '',
                country: this.defaultCountry,
                was: null,
                settings: {},
                dynamicFieldsValues: []
            }
        }
    },

    created: function created() {
        if (!this.form.dynamicFieldsValues) {
            this.form.dynamicFieldsValues = {};
        }
    },

    methods: {
        goBack()
        {
            window.location.href = '/restaurants';
        },

        sanitizeDecimalPoint(val)
        {
            return (val ? val.replace(",",".") : val);
        },

        sanitizeIncorrectFloatChars(val)
        {
            val = this.sanitizeDecimalPoint(val);
            return (val ? val.replace(/[^0-9.]/,"") : val);
        },

        correctBasicInputDecimals(vmodelName,$event)
        {
            this.form.settings[vmodelName] = this.sanitizeIncorrectFloatChars($event.target.value);
        },

        correctDynamicFieldsDecimals(typeId, $event) {
            this.form.dynamicFieldsValues[typeId] = this.sanitizeDecimalPoint(
                $event.target.value
            );
        },

        formatDynamicFieldsAmount(typeId, $event) {
            let sanitized = this.sanitizeFloatInput($event.target.value, 2);
            if (Number.isNaN(sanitized)) sanitized = "0.00";

            this.form.dynamicFieldsValues[typeId] = sanitized;
            $("#field_" + typeId).val(sanitized); // lebo vue je dementne a model sice refreshne, ale input s v-model uz nie
        },
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/restaurant/Form.js